import { GoogleAuthProvider } from "@/features";
import {
  View,
  GuestOnlyPage,
} from "@/components";

import {
  SignUpRegistrationSteps,
  SignUpPageContainer,
  SignUpPageHeader,
  SignUpHeroBanner,
} from "..";
import { Flex } from "@vetty/ui";

/**
 * SignUpPageView Component
 *
 * Main sign up page with view component.
 * Handles sign up flow for new users.
 */
export const SignUpPageView = () => {
  return (
    // Only guests can access the sign up page
    <GuestOnlyPage redirectTo={"/"}>
      {/* Google Auth Provider */}
      <GoogleAuthProvider>
        {/* Main content container */}
        <View>
          <Flex direction="column">
            {/* Page header with navigation */}
            <SignUpPageHeader />

            {/* Main content area */}
            <SignUpPageContainer>
              {/* Desktop marketing banner */}
              <SignUpHeroBanner />

              {/* Sign up registration steps */}
              <SignUpRegistrationSteps />
            </SignUpPageContainer>
          </Flex>
        </View>
      </GoogleAuthProvider>
    </GuestOnlyPage>
  );
};
